import axios from "@/api/axios";

import { DefaultService } from "./DefaultService";
import { TenancyInterface } from "@/api/Interfaces/TenancyInterface";

export default class Tenancy extends DefaultService {
  public static readonly url = "tenancies/";

  static getTenancy(slug_id: string): Promise<TenancyInterface> {
    return new Promise((resolve, reject) => {
      axios
        .get(`${this.url}${slug_id}`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error instanceof Error ? error : new Error(String(error)));
        });
    });
  }

  static getTenanciesWithServices(): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .get(`tenancies-with-services`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error instanceof Error ? error : new Error(String(error)));
        });
    });
  }
}
